<template>
<!-- Top Bar Start -->
<div class="topbar" style="height:70px">
    <!-- LOGO -->
    <div class="topbar-left">
        <div class="text-center">
            <a class="logo">
                <i class="ti-cloud"></i>
                <span>Locus Mapping</span>
            </a>
        </div>
    </div>

    <!-- Button mobile view to collapse sidebar menu -->

    <nav class="navbar-custom">
        
        
        <ul class="list-inline float-right">
            <b-dropdown variant="default" toggle-class="nav-link dropdown-toggle shadow-none" no-caret>
                <template #button-content>
                    <span class="mdi mdi-account-circle mdi-24px" v-wave style="font-size: x-large;padding: 0.85em 1.1em;"></span>
                </template>
                <b-dropdown-item href="#" @click="changePassword" v-if="tenantId !== userName">{{ $t("button.chagne_password") }}</b-dropdown-item>
                <b-dropdown-item href="#" @click="logout">Logout</b-dropdown-item>
            </b-dropdown>
        </ul>
        <ul class="list-inline float-right" @click="goToHelpSite">
            <div style="color: #ffffff;line-height:68px;font-weight: bold;cursor: pointer;">{{ $t("help") }}</div>
        </ul>
    </nav>

    <b-modal v-model="updatePasswordModal" :title="$t('button.chagne_password')" @ok="updatePassword">

            <form>
                <b-form-group id="name-group" v-if="error_password !== ''">
                    <div class="attr_warning">{{error_password}}</div>
                </b-form-group>

                <b-form-group id="name-group" :label="$t(`user_manage.user_name`)" label-for="name-input" >
                    <b-form-input id="name-input" v-model="newTenant.username" readonly></b-form-input>
                </b-form-group>

                <b-form-group id="password-group" :label="$t(`user_manage.password`)" label-for="password-input">
                    <b-form-input id="password-input" type="password" v-model="newTenant.password" 
                    autocomplete="new-password" 
                    required></b-form-input>
                </b-form-group>

                    <b-form-group id="confirm-password-group" :label="$t(`user_manage.confirm_password`)" label-for="confirm-password-input">
                    <b-form-input id="confirm-password-input" type="password" v-model="newTenant.confirmPassword" ></b-form-input>
                </b-form-group> 

            </form>
        </b-modal>
</div>
<!-- Top Bar End -->
</template>

<script>
import {
    API,
    Auth
} from "aws-amplify";
import global from "../../Global.vue";
import {
    changeUserPassword
} from "../../graphql/mutations";

export default {
    data() {
        return {
            tenantId: "",
            userName: "",
            error_password: "",
            updatePasswordModal: false,
            newTenant: {
                "username": "",
                "password": "",
                "confirmPassword": ""
            },
            error_confirm_password: this.$t("user_manage.password_mismatch"),
        }
    },
     async created() {
        this.tenantId = sessionStorage.getItem(global.tenantId);
        this.userName = sessionStorage.getItem(global.userName);
    },
    methods: {
        logout() {
            Auth.signOut()
            this.$router.push("/");
        },
        goToHelpSite(){
            window.open('https://rflocus.com/help/', '_blank');
            this.tabIndex = 0;
        },
        changePassword() {
            this.error_password = ""
            this.updatePasswordModal = true
            this.newTenant = {
                "username": sessionStorage.getItem(global.userName),
                "password": "",
                "confirmPassword": ""
            }
            
        },
        async updatePassword(bvModalEvent) {
            bvModalEvent.preventDefault();

            if(this.newTenant.password != this.newTenant.confirmPassword){
                this.error_password = this.error_confirm_password
                return
            }

            var variables = {
                "username": this.newTenant.username,
                "password": this.newTenant.password
            }

            const response = await API.graphql({
                query: changeUserPassword,
                variables: variables
            })
            if(response.data.changeUserPassword !== "OK") {
                this.error_password = response.data.changeUserPassword
            } else {
                this.updatePasswordModal = false
            }

        },
    },
};
</script>

<style lang="scss">
.navbar-custom .float-right {
    .btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
        border-color: transparent !important;
    }
}

</style>
